import React, { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../../styles/PhotoBooth.css';
import '../../styles/Ppulbatu/2Photobooth.css';

function PhotoBoothPpulbatu() {
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const existingImages = location.state?.existingImages || [];
  const selectedFrame = location.state?.selectedFrame;
  const [capturedImages, setCapturedImages] = useState(existingImages);
  const [countdown, setCountdown] = useState(10);
  const [takingPhotos, setTakingPhotos] = useState(false);
  const [photoCount, setPhotoCount] = useState(0);
  const [flashVisible, setFlashVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [intervalTime, setIntervalTime] = useState(5);
  const [viewHeight, setViewHeight] = useState(window.innerHeight);
  const [showingStartMessage, setShowingStartMessage] = useState(false);
  const overlaySequence = selectedFrame.overlays;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setViewHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let interval;

    if (takingPhotos && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    }

    if (countdown === 0 && photoCount < 4) {
      triggerFlash();
      capture();
      setCountdown(intervalTime);
      setPhotoCount(prev => prev + 1);
    }

    if (photoCount === 4) {
      clearInterval(interval);
      setTakingPhotos(false);
      setTimeout(() => {
        if (existingImages.length > 0) {
          navigate('/select/Ppulbatu', { state: { images: capturedImages, selectedFrame } });
        } else {
          navigate('/confirm/Ppulbatu', { state: { images: capturedImages, selectedFrame } });
        }
      }, 500);
    }

    return () => clearInterval(interval);
  }, [countdown, takingPhotos, photoCount, capturedImages, navigate, intervalTime]);

  useEffect(() => {
    if (existingImages.length > 0) {
      setShowingStartMessage(true);
      const timer = setTimeout(() => {
        setShowingStartMessage(false);
        startPhotoSession();
      }, 1000);
      return () => {
        clearTimeout(timer);
        setShowingStartMessage(false);
      };
    }
  }, [existingImages]);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImages(prev => [...prev, imageSrc]);
  };

  const triggerFlash = () => {
    setFlashVisible(true);
    setTimeout(() => setFlashVisible(false), 150);
  };

  const startPhotoSession = () => {
    if (existingImages.length === 0) {
      setCapturedImages([]);
    }
    setPhotoCount(0);
    setTakingPhotos(true);
    setCountdown(intervalTime);
  };

  const handleIntervalChange = (e) => {
    setIntervalTime(Number(e.target.value));
  };

  const getWebcamDimensions = () => {
    if (isMobile) {
      const vw = Math.min(window.innerWidth * 0.9, 480);
      return { width: vw, height: vw * 3/4 };
    } else {
      return { width: 600, height: 450 };
    }
  };

  const webcamDimensions = getWebcamDimensions();

  const videoConstraints = {
    facingMode: 'user',
    width: webcamDimensions.width,
    height: webcamDimensions.height,
    aspectRatio: 4/3
  };

  return (
    <div className="PhotoBooth">
      <Link to="/frame-selection/Ppulbatu" className="frame-back-link">
        ← Back
      </Link>

      {isMobile && !takingPhotos && existingImages.length === 0 && (
        <div className="mobile-start-button-wrapper">
          <button onClick={startPhotoSession} className="start-button">
            Start!
          </button>
        </div>
      )}
      {isMobile && takingPhotos && (
        <div className="photo-counter">
          {photoCount}/4 Photos
        </div>
      )}

      <div className="photo-layout">
        <div
          className="webcam-container"
          style={{
            width: `${webcamDimensions.width}px`,
            height: `${webcamDimensions.height}px`,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#000',
            borderRadius: '18px',
          }}
        >
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            mirrored={true}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '18px',
            }}
          />
          <img
            src={`/img/Ppulbatu/${overlaySequence[Math.min(photoCount, overlaySequence.length - 1)]}`}
            alt="Overlay"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '18px',
              pointerEvents: 'none',
              zIndex: 1
            }}
          />
          {flashVisible && <div className="flash-overlay" />}
          {takingPhotos && (
            <div className="countdown-overlay">{countdown}</div>
          )}
        </div>

        <div className="info-container">
          {!takingPhotos && !isMobile && existingImages.length === 0 && (
            <div className="controls-stack">
              <div className="interval-selector">
                <label htmlFor="interval">Select Interval:</label>
                <select id="interval" value={intervalTime} onChange={handleIntervalChange}>
                  <option value={5}>5 Seconds</option>
                  <option value={10}>10 Seconds</option>
                </select>
              </div>
              {!isMobile && !takingPhotos && (
                <button onClick={startPhotoSession} className="start-button">
                  Start!
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PhotoBoothPpulbatu;
